export default class TeamResult
{
    constructor(teamName, year)
    {
        this.Team = teamName;
        this.Year = year;
    }
    
    Team = '';
    Year = 1900;
    TeamResultMonth = [];
}